import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { registerSW } from "virtual:pwa-register";
import { toast } from "sonner";
import { queryClient } from "./lib/query-client";
import { Toaster } from "./components/ui/sonner";
import App from "./App.tsx";
// Self-hosted (not a Google Fonts CDN link) so the installed PWA still has
// numerals offline — vite-plugin-pwa precaches the one subset file this app
// ever requests (see the globPatterns comment in vite.config.ts).
import "@fontsource-variable/inter/wght.css";
import "./index.css";

// Dark theme is the default (and only) theme.
document.documentElement.classList.add("dark");

// Chunks are fingerprinted per deploy; a stale shell 404s on new-hash chunks.
// Catching the event and reloading gets the fresh shell automatically.
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  window.location.reload();
});

// Register the service worker with a user-visible refresh prompt so an update
// is never silently applied while the app is in use.
const updateSW = registerSW({
  onNeedRefresh() {
    toast("Update ready", {
      duration: Infinity,
      action: {
        label: "Refresh",
        onClick: () => void updateSW(true),
      },
    });
  },
  onOfflineReady() {},
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        richColors
        position="top-center"
        offset={{ top: "calc(var(--safe-top) + 16px)" }}
        mobileOffset={{ top: "calc(var(--safe-top) + 12px)" }}
      />
    </QueryClientProvider>
  </StrictMode>,
);
